import { GetterTree } from 'vuex';
import {configurationOptions, rootStore} from "@/store/types";

export type Getters = {
    getCurrentNavigationTitle(state: configurationOptions): (name: string) => string;
    getCurrentNavigationDescription(state: configurationOptions): (name: string) => string;
    getIntroductionText(state: configurationOptions): string;
    getIntroductionHeading(state: configurationOptions): string;
    getIntroductionButtonText(state: configurationOptions): string;
}

export const getters: GetterTree<configurationOptions, rootStore> & Getters = {

    getCurrentNavigationTitle(state: configurationOptions): (name: string) => string {
        return (name) =>{
            for(const prop in state.navigation){
                if(state.navigation[prop].name === name){
                    return state.navigation[prop].displayName
                }
            }
            return 'default string';
        }
    },
    getCurrentNavigationDescription(state: configurationOptions): (description: string) => string {
        return (description) =>{
            for(const prop in state.navigation){
                if(state.navigation[prop].name === description){
                    return state.navigation[prop].displayDescription
                }
            }
            return 'default string';
        }
    },
    getIntroductionText(state: configurationOptions): string {
        return state.introduction.text;
    },

    getIntroductionButtonText(state: configurationOptions): string {
        return state.introduction.button;
    },
    getIntroductionHeading(state: configurationOptions): string {
        return state.introduction.heading;
    }

};